function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

(function (algolia) {
    if (!algolia.config.autocomplete_enabled) return;

    var _ = algolia._,
        $ = algolia.jQuery;

    var autocomplete;

    function index(name) {
        return algolia.client.initIndex('' + algolia.config.index_prefix + name);
    }

    function autocompleteSection(section) {
        var params = autocomplete[section];
        if (params.enabled !== true) return null;

        var templates = {
            empty: function displayEmptyResultSet(props) {
                return algolia.render(params.templates.empty, props);
            },
            suggestion: function displaySuggestion(hit) {
                return algolia.render(params.templates.hit, hit);
            }
        };

        // "Termékek (N)" + "Mutasd mind" fejléc - a content (Algolia válasz) a ténylegesen megjelenő találatokat tartalmazza
        if (params.templates.header) {
            templates.header = function displayHeader(props, content) {
                if (props.isEmpty) {
                    return '';
                }

                return algolia.render(params.templates.header, {
                    count: (content && content.hits) ? content.hits.length : '',
                    query: encodeURIComponent(props.query)
                });
            }
        }

        if (params.templates.footer) {
            templates.footer = function displayFooter(props, content) {
                if (content.nbHits <= params.hitsPerPage) return null;

                return algolia.render(params.templates.footer, {
                    query_name: props.query,
                    query: encodeURI(props.query),
                    nbHits: content.nbHits
                });
            }
        }

        return {
            name: section,
            source: $.fn.autocomplete.sources.hits(params.index, {
                hitsPerPage: params.hitsPerPage,
                highlightPreTag: '<span class="aa-highlight">',
                highlightPostTag: '</span>'
            }),
            displayKey: 'title',
            templates: templates
        }
    };

    function readjust($this) {
        var data = $this.data('aaAutocomplete');
        if (!data) {
            return;
        }

        var $node = data.$node;
        var $dropdown = data.dropdown.$menu;
        var $form = $this.closest('form');
        var algoliaIsMobil = $form.hasClass('search-bar__mobile');

        if (!$form.length) {
            $form = $('.search-bar__desktop:visible, .search-bar__mobile:visible').first();
        }

        if (!$form.length) {
            return;
        }

        var vpWidth = document.body.clientWidth;
        var width = $form.outerWidth();
        var offset = $form.offset();
        var left = offset.left;
        var right = vpWidth - width - left;
        var top = offset.top;
        var height = $this.outerHeight();

        var align = left < right ? 'left' : 'right';
        var dist = Math.min(left, right);

        // For small centered inputs, take half the screen
        if (4 * dist > vpWidth) {
            align = 'left';
            dist = Math.round(vpWidth / 4);
        }

        var newWidth = vpWidth - 2 * dist;

        // For big inputs, follow the input
        if (width >= 600) {
            align = 'left';
            dist = left;
            newWidth = width;
        }

        if (algoliaIsMobil) {
            align = 'left';
            dist = left;
            newWidth = width;
        }

        $node
            .css('left', '')
            .css('right', '')
            .css('top', (top + height + 8) + 'px')
            .css(align, dist)
            .css('width', '' + newWidth + 'px');

        var suffix = 'lg';
        if (newWidth < 300) suffix = 'xs';
        else if (newWidth < 600) suffix = 'sm';
        else if (newWidth < 900) suffix = 'md';

        if (newWidth < 301 && !algoliaIsMobil) {
            $node
                .css('right', '0')
                .css('border', '0')
                .css('width', '100%');
        }

        $dropdown
            .removeClass('aa-dropdown-menu-size-xs')
            .removeClass('aa-dropdown-menu-size-sm')
            .removeClass('aa-dropdown-menu-size-md')
            .removeClass('aa-dropdown-menu-size-lg')
            .addClass('aa-dropdown-menu-size-' + suffix);
    }

    autocomplete = algolia.autocomplete = {
        articles: {
            enabled: algolia.config.index_articles,
            hitsPerPage: algolia.config.articles_autocomplete_hits_per_page,
            index: algolia.client.initIndex(algolia.config.article_algolia_index),
            templates: {
                empty: algolia.compileTemplate('autocomplete_articles_empty'),
                hit: algolia.compileTemplate('autocomplete_article')
            }
        },
        collections: {
            enabled: algolia.config.index_collections,
            hitsPerPage: algolia.config.collections_autocomplete_hits_per_page,
            index: index('collections'),
            templates: {
                empty: algolia.compileTemplate('autocomplete_collections_empty'),
                hit: algolia.compileTemplate('autocomplete_collection')
            }
        },
        colors: algolia.config.colors,
        debug: algolia.config.autocomplete_debug,
        poweredBy: algolia.config.powered_by,
        products: {
            enabled: algolia.config.index_products,
            hitsPerPage: algolia.config.products_autocomplete_hits_per_page,
            index: index('products'),
            templates: {
                empty: algolia.compileTemplate('autocomplete_products_empty'),
                header: algolia.compileTemplate('autocomplete_products_header'),
                footer: algolia.compileTemplate('autocomplete_footer'),
                hit: algolia.compileTemplate('autocomplete_product')
            },
        },
        selector: algolia.config.input_selector + ', .algolia-shopify-autocomplete',
        storeName: algolia.storeName,
        templates: {
            dropdown: algolia.compileTemplate('autocomplete'),
            empty: '<div></div>',
            style: algolia.compileTemplate('autocomplete.css')
        }
    };

    /*
    if (autocomplete.poweredBy) {
        console.log('Algolia: Autocomplete');
    }
    */

    $('.search-bar-clear, #cross-icon').on('click', function () {
        let $search_form = $('.search-bar__new');
        $search_form.val('');
        autocomplete.$input.autocomplete('val', '');
        $('.search-bar-clear').hide();
    });

    $('.search-bar__new').on('click', function () {
        if ($(this).val()) {
            autocomplete.$input.autocomplete('open');
        }
    });

    $(document).mousedown(function(e) {
        if ($('.search-bar__new').val()) {
            var containers = $(".algolia-autocomplete, .search-bar__desktop");
            if (!containers.is(e.target) && containers.has(e.target).length === 0) {
                $('.search-bar__desktop').removeClass('input--filled');
            }
        }
    });

    algolia.appendStyle(algolia.render(autocomplete.templates.style, {
        colors: autocomplete.colors
    }));

    $(document).ready(function mainAutocomplete() {
        autocomplete.$input = $(autocomplete.selector);
        autocomplete.$input.autocomplete({
            debug: autocomplete.debug,
            hint: false,
            appendTo: 'body',
            templates: {
                dropdownMenu: algolia.render(autocomplete.templates.dropdown, {
                    storeName: autocomplete.storeName,
                    with: {
                        articles: autocomplete.articles.enabled,
                        collections: autocomplete.collections.enabled,
                        poweredBy: autocomplete.poweredBy,
                        products: autocomplete.products.enabled
                    }
                }),
                empty: autocomplete.templates.empty
            }
        }, _.compact([
            autocompleteSection('collections'),
            autocompleteSection('articles'),
            autocompleteSection('products')
        ]));

        // Hack to handle buggy onclick event on iOS
        autocomplete.$input.each(function () {
            var data = $(this).data('aaAutocomplete');
            var dropdown = data.dropdown;
            var suggestionClass = '.' + dropdown.cssClasses.prefix + '-' + dropdown.cssClasses.suggestion;
            var onSuggestionClick = dropdown._onSuggestionClick.bind(dropdown);

            var touchmoved;
            dropdown.$menu.on('touchend', suggestionClass, function (e) {
                e.preventDefault();
                if (touchmoved != true) {
                    onSuggestionClick.apply(this, arguments);
                }
            }).on('touchmove', function () {
                touchmoved = true;
            }).on('touchstart', function () {
                touchmoved = false;
            });
        });

        autocomplete.$input.on('autocomplete:selected', function (obj, datum, name) {
            if (name === 'products') {
                window.location.href = '/' + name + '/' + datum.handle + (datum.objectID !== datum.id ? '?variant=' + datum.objectID : '');
            } else if (name === 'articles') {
                window.location.href = '/blogs/' + datum.blog.handle + '/' + datum.handle;
            } else {
                window.location.href = '/' + name + '/' + datum.handle;
            }
        })

        autocomplete.$input.on('autocomplete:redrawn', function () {
            readjust($(this));
            translateJudgemeBadge($('.algolia-autocomplete'));
        });

        autocomplete.$input.on('autocomplete:closed', function () {
            $('.search-bar__desktop').removeClass('input--filled');
            $('.search-bar__mobile').removeClass('input--filled');
        });

        autocomplete.$input.on('input',
            _.debounce(function () {
                window.dataLayer.push({
                    'event': 'Site Search',
                    'searchQuery': $(this).val(),
                    'searchFormattedParameters': null,
                    'searchNumberOfHits': null
                });
            }, 1000)
        );

        $(window).resize(function () {
            autocomplete.$input.each(function () {
                readjust($(this));
            });
        });
    });
}(algoliaShopify));
